import React from "react";
import { View } from "react-native-web";

const Wrapper = ({ children, backgroundColor="#F3F4F6"}: any) => {
    return (
    <View
      style={{
        height: "100%",
        padding: 12,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: backgroundColor,
        position:'relative'
      }}
        >
            {children}
    </View>
    )
}

export default Wrapper;